import { Component, effect, inject, input, Input, OnInit, ViewChild, CUSTOM_ELEMENTS_SCHEMA} from '@angular/core';
import {
    IonButton, IonButtons,
    IonHeader,
    IonIcon,
    IonMenuButton, IonMenuToggle, IonPopover, IonToggle,
    IonToolbar, PopoverController
} from "@ionic/angular/standalone";
import {Router, RouterLink} from "@angular/router";
import {LanguageService} from "../../core/language.service";
import {SubMenuComponent} from "./sub-menu/sub-menu.component";
import {smLinks} from '../../configs/content/sm-links';
import {components} from '../../configs/config';
import {CommonTextService} from '../../core/common-text.service';
import {LogoComponent} from './logo/logo.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {HeaderFilterComponent} from '../header-filter/header-filter.component';
import {accessibility} from 'ionicons/icons';
import {AuthService} from '../../auth/auth.service';
import {ToggleThemeService} from './toggle.theme.service';
import {ListingFilterComponent} from '../../properties/listing-page/listing-filter/listing-filter.component';
import {ShareButtonDirective} from "ngx-sharebuttons";
import {TranslateModule} from '@ngx-translate/core';

@Component({
    selector: 'app-header',
    imports: [
        IonIcon,
        RouterLink,
        IonHeader,
        IonToolbar,
        IonMenuButton,
        IonButton,
        LogoComponent,
        FormsModule,
        ReactiveFormsModule,
        HeaderFilterComponent,
        IonButtons,
        IonToggle,
        IonMenuToggle,
        ListingFilterComponent,
        IonPopover,
        ShareButtonDirective,
        TranslateModule
    ],
    templateUrl: './header.component.html',
    styleUrl: './header.component.scss',
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class HeaderComponent implements OnInit {
  @Input() isScrolled: boolean = false;
  @Input() isHome: boolean = false;
  @Input() showMobilePropertyHeader: boolean = false;
  @Input() showMobilePropertySearchHeader: boolean = false;
  filled = input(false)
  languageService: LanguageService = inject(LanguageService);
  popoverController: PopoverController = inject(PopoverController);
  commonTextService: CommonTextService = inject(CommonTextService);
  navigationContent: any = {
    navigationLinks: [
      {
        text: 'Rent',
        link: '/listings/rent',
      },
      {
        text: 'About SATEL',
        link: '/about-satel',
      },
      {
        text: 'Our Services',
        link: '/our-services',
      },
      {
        text: 'Explore',
        links: [
          {
            text: 'Your Property Guide',
            link: '/blog/post',
          },
          {
            text: 'Satel Jobs',
            link: '/careers',
          }
        ],
      },
      {
        text: 'Contact us',
        link: '/contact',
      }
    ]
  };
  authService: AuthService = inject(AuthService);
  themeService: ToggleThemeService = inject(ToggleThemeService);
  constructor() {
    effect(async () => {
      if (this.languageService.lang()) {
        this.navigationContent = await this.languageService.loadContent(components.navigation);
      }
    });
  }
  async ngOnInit() {
    this.navigationContent = await this.languageService.loadContent(components.navigation);
    }

  async openSubMenu($event: MouseEvent, subNavigation: any) {
    // subNavigation = [
    //   {
    //     text: 'Your Property Guide',
    //     link: '/blog/post',
    //   },
    //   {
    //     text: 'Satel Jobs',
    //     link: '/careers',
    //   }
    // ]
    const popover = await this.popoverController.create({
      component: SubMenuComponent,
      event: $event,
      componentProps: {subNavigation, dir: this.languageService.dir()},
      cssClass: 'header-popover'
    });
    await popover.present();
  }
  protected readonly smLinks = smLinks;
  protected readonly accessibility = accessibility;

  router: Router = inject(Router);
  @ViewChild('popover') popover!: IonPopover;
  generateUrl() {
    return `https://satel.sa${this.router.url}`
  }
  copyUrl() {
    navigator.clipboard.writeText(this.generateUrl());
    this.popover.dismiss();
  }
  goBack() {
    window.history.back();
  }
}
